<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <ItemsWaiting v-if="is_fetch"/>

    <div v-else style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex justify-content-between">
        <div class="text-right m-4">
          <h5 style="font-size: 1vw !important"> شناسایی مسئله </h5>
        </div>

        <div class="d-flex justify-content-between gap-3">
          <button class="btn btn-primary btn-submit-1 btn-auto-size" style="height: 2.5vw !important; margin-top: .7vw;" @click="clearBrowserCache">پاک کردن کش مرورگر</button>

          <div v-if="allItems.length" class="d-flex">
            <a style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1"
               v-if="seconder_ban || approver_ban" v-show="!status_show" @click="infoCancelledModal=true"> دلایل عدم
              تایید</a>

            <!--          <a  :href="`${this.download_url}/Problem_identification/all/pdf/by/id/${id_user}?token=${$cookies.get('id_login')}`"
                         style="margin-top: 1.3vw;margin-left:1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
                        PDF</a>-->

          </div>
        </div>

      </div>
      <center v-if="status_approver">
        <div class="alert alert-success w-25">
          تایید نهایی!
        </div>
      </center>
      <center v-if="!status_show && allItems.length">

        <div v-if="seconder_ban" class="alert alert-warning w-50" @click="infoCancelledModal=true">
          <div v-if="this.$cookies.isKey('type_2')">
            کاربرگ توسط مدیر ؛ تایید نشد!
          </div>
          <div v-else>
            این کاربرگ قبلا توسط شما رد شده است و در حال حاضر اصلاح شده است

          </div>
        </div>
      </center>
      <center v-if="!status_show">
        <div v-if="approver_ban" @click="infoCancelledModal=true" class="alert alert-info" style="width: 30vw;">
          کاربرگ توسط مدیر سامانه ؛ تایید نشد!
        </div>
      </center>
      <center v-if="status_seconder_step">
        <div v-if="status_seconder" class="alert alert-info w-50">
          در انتظار تایید توسط مدیر
        </div>
        <div v-if="!status_seconder" class="alert alert-info" style="width: 24vw;">
          در انتظار تایید توسط مدیر سامانه
        </div>
      </center>
      <div v-if="show_insert && not_show" class="d-flex flex-column p-4">

        <div class="d-flex flex-nowrap w-100 justify-content-between">
          <div>
            <label class="required">نشانه مسئله</label>
            <textarea v-model="sign" class="form-control" cols="30" rows="30"></textarea>
          </div>
          <div class="mx-2">
            <label class="required">عنوان مسئله</label>
            <textarea v-model="title" class="form-control" cols="30" rows="30"></textarea>

          </div>

          <div>
            <label class="required">سطح مسئله</label>
            <select v-model="type" name="" id="" class="form-select">
              <option value="درون دستگاه اجرایی">درون دستگاه اجرایی</option>
              <option value="بخش تحت تولی">بخش تحت تولی</option>
              <option value="محیط کلان">محیط کلان</option>
            </select>
          </div>

          <div class="mx-2">
            <label class="required nowrap">دوره چرخه</label>
            <select v-model="selectedEventId" name="" id="" class="form-select">
              <option v-for="event in events" :key="event.id" :value="event.id" :selected="event.status === 1 && !is_update">{{ event.name }}</option>
            </select>
          </div>

          <div class="mx-2">
            <label class="required">ماموریت</label>
            <v-select :options="allItemsDetermining_Mission" dir="rtl" v-model="Determining_Mission" label="axis"
                      style="width: 12vw;   border-radius: .5vw">
              <template v-slot:no-options>موردی یافت نشد</template>
            </v-select>
          </div>

          
          
          <div class="mx-2 ">
  <label>کلان خدمت</label>
  

  <button @click="allProcessModal=true" class="btn bg-white"
                    style="border: 1px solid #777; height: 2vw; display: grid; place-content: center">
              {{ ListProcessSelected[0] ? ListProcessSelected.length +' مورد انتخاب شده' : 'انتخاب کنید' }}
            </button>
</div>

          <div class="mx-2">
        
            <label>زیر خدمت</label>
            <button @click="allSubProcessModal=true" class="btn bg-white"
                    style="border: 1px solid #777; height: 2vw; display: grid; place-content: center">
              {{ ListSubSelected[0] ? ListSubSelected.length +' مورد انتخاب شده' : 'انتخاب کنید' }}
              
            </button>
          </div>
          <div class="col-2" v-if="false">
            <label class="required">دوره چرخه</label>
            <select v-model="Periods_id" name="" id="" class="form-select">
              <option v-for="item in allItemsListPeriods" :value="item.id">{{ item.name }}</option>
            </select>
          </div>


        </div>


        <div class="d-flex flex-nowrap w-100 justify-content-start">
          <div>
            <label>دستگاه های تابعه همکار </label>
            <input v-model="collaborative_devices" type="text" class="form-control">
          </div>
<!--          <div v-if="false" style="margin-right: 1vw;">-->
<!--            <label>دوره</label>-->
<!--            <select v-model="period" name="" id="" class="form-select">-->
<!--              <option value="دوره 1">دوره 1</option>-->
<!--              <option value="دوره2">دوره 2</option>-->
<!--              <option value="دوره 3">دوره3</option>-->
<!--              <option value="دوره 4">دوره 4</option>-->
<!--            </select>-->
<!--          </div>-->
          <button v-if="!is_update" @click.prevent="store" style="margin-top: 1.8vw;transform: translateX(-1vw)"
                  class="btn btn-primary btn-submit-1">ذخیره
          </button>
          <div class="d-flex" v-else>
            <button @click.prevent="update(id_item)" style="margin-top: 1.3vw; margin-right: 1vw;"
                    class="btn btn-primary btn-submit-1">ویرایش
            </button>
            <Reset @click.prevent="resetData"
                   style="width: 1.5vw; height: 1.5vw; transform: translateY(1.3vw); cursor: pointer; margin-right: 1vw;"/>
          </div>

        </div>
        <br>
        <center>
          <hr>
        </center>
      </div>


      <div class="p-4 table-responsive">

        <center v-show="!allItems.length">
          <span v-if="$cookies.isKey('type_2') && isWrite">مسئله وجود ندارد</span>
          <span v-else-if="!isWrite">دوره ای برای  پایش بهره وری این شرکت فعال نمی باشد
</span>
          <span v-else>
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
        </center>
        <div class="d-flex justify-content-between align-items-center w-100">
          <div v-if="allItems.length" class="d-flex flex-column align-items-center justify-content-center my-3 card bg-white shadow"
               style="width: 20vw;">
            <select
                v-model="type_show"
                @change="toggleType(type_show)"
                class="form-select cursor-pointer"
                aria-label="نوع نمایش مسائل"
            >
              <option :value="1" selected>همه مسائل</option>
              <option :value="2">مسائل تکمیل شده</option>
              <option :value="3">مسائل تکمیل نشده</option>
            </select>
          </div>

          <div class="position-relative">
            <!-- Button for Filter -->
            <button v-if="allItems.length" @click.prevent="toggleModal" class="btn btn-submit-1 btn-primary mx-3">
              <span> فیلتر چرخه  </span>
              <span class="bg-danger rounded-circle d-flex align-items-center justify-content-center" style="width: 1vw; padding: 0.4vw;  height: 1vw;" v-if="selected_periods.length!==0">{{selected_periods.length}}</span>
            </button>

            <!-- Dropdown multi-select -->
            <div v-if="filterModal" class="card bg-white"
                 style="z-index: 99999999999999999999999999;   width: 10vw; position:absolute; top: -147%; height:10vw; overflow-y: scroll">
              <div class="sticky-header d-flex justify-content-between border-bottom align-items-center">
                <span class="mx-1">دوره ها</span>
                <span style="font-size: 0.7vw" @click.prevent="toggleModal">❌</span>
              </div>
              <div class="w-100 h-auto mb-5 d-flex flex-column p-2 ">
                <label v-for="option in allItemsListPeriods" :key="option.id" class="border-bottom">
                  <input type="checkbox" v-model="selected_periods" :value="option.id"/>
                  {{ option.name }}
                </label>
              </div>
              <div class="sticky-header d-flex align-items-center justify-content-center"
                   style="top: unset; bottom: 0; ">
                <button style="width: 4vw !important;" @click.prevent="searchPeriodsFilter(true)"
                        class="btn btn-submit-1 w-100 mb-2 mt-2 btn-primary mx-2">تایید
                </button>
                <Reset @click.prevent="searchPeriodsFilter(false)" style="width: 1vw; height: 1vw; cursor: pointer"/>
              </div>

            </div>

          </div>
        </div>

        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

          <table class="table table-striped" v-if="allItems.length && type_show === 1 && !search_mode">
            <tbody>
            <tr>
              <th rowspan="2"><strong>ردیف</strong></th>
              <th rowspan="2"><strong>نشانه مسئله</strong></th>
              <th rowspan="2"><strong>عنوان مسئله</strong></th>
              <th rowspan="2"><strong>نماگر مسئله</strong></th>
              <th rowspan="2"><strong>سطح مسئله</strong></th>
              <th rowspan="2"><strong>ماموریت</strong></th>
              <th colspan="3"><strong>خدمت متناظر</strong></th>
              <th rowspan="2"><strong>دوره چرخه </strong></th>
              <th v-if="show_insert" rowspan="2" colspan="3"><strong>عملیات</strong></th>
            </tr>
            <tr>
              <th>کلان خدمت</th>
              <th>زیرخدمت</th>
              <th>دستگاه‌های تابعه همکار</th>
            </tr>
            <tr v-for="(item, index) in allItems">
              <td>{{ index + 1 }}</td>
              <td>{{ item.sign }}</td>
              <td>{{ item.title }}</td>
              <td STYLE="width: 8vw;">
                <span class="btn btn-submit-1 btn-primary" style="cursor: pointer;  "
                      @click="photographerFetchAll(item.id)">تکمیل / بروزرسانی</span>
              </td>
              <td>{{ item.type }}</td>
              <td>{{ item.determining_missions && item.determining_missions.axis }}</td>
              <td>{{ item.process_id && item.process_id }}</td>
              <td>
                <span style="cursor: pointer; color: blue !important"
                      @click="showItemsSubProcess(item.id)">مشاهده</span>
              </td>
              <td>{{ item.collaborative_devices }}</td>
              <td>{{ (item.circle && item.circle.name) ?? '--' }}</td>

              <td v-if="show_insert">
                <div class="d-flex justify-content-evenly">
                  <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img"
                                                                        src="/img/pen.6428fd02.svg" alt="edit"></a>
                  <a @click.prevent="deleteMethod(item.id)" style="margin-right: 0.3vw;" href="#"><img
                      class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          <table  class="table table-striped" v-if="all_search.length  && search_mode">
            <tbody>
            <tr>
              <th rowspan="2"><strong>ردیف</strong></th>
              <th rowspan="2"><strong>نشانه مسئله</strong></th>
              <th rowspan="2"><strong>عنوان مسئله</strong></th>
              <th rowspan="2"><strong>نماگر مسئله</strong></th>
              <th rowspan="2"><strong>سطح مسئله</strong></th>
              <th rowspan="2"><strong>ماموریت</strong></th>
              <th colspan="3"><strong>خدمت متناظر</strong></th>
              <th rowspan="2"><strong>دوره چرخه </strong></th>
              <th v-if="show_insert" rowspan="2" colspan="3"><strong>عملیات</strong></th>
            </tr>
            <tr>
              <th>کلان خدمت</th>
              <th>زیرخدمت</th>
              <th>دستگاه‌های تابعه همکار</th>
            </tr>
            <tr v-for="(item, index) in all_search">
              <td>{{ index + 1 }}</td>
              <td>{{ item.sign }}</td>
              <td>{{ item.title }}</td>
              <td STYLE="width: 8vw;">
                <span class="btn btn-submit-1 btn-primary" style="cursor: pointer;  "
                      @click="photographerFetchAll(item.id)">تکمیل / بروزرسانی</span>
              </td>
              <td>{{ item.type }}</td>
              <td>{{ item.determining_missions && item.determining_missions.axis }}</td>
              <td>{{ item.processes && item.processes.title }}</td>
              <td>
                <span style="cursor: pointer; color: blue !important"
                      @click="showItemsSubProcess(item.id)">مشاهده</span>
              </td>
              <td>{{ item.collaborative_devices }}</td>
              <td>{{ (item.circle && item.circle.name) ?? '--' }}</td>

              <td v-if="show_insert">
                <div class="d-flex justify-content-evenly">
                  <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img"
                                                                        src="/img/pen.6428fd02.svg" alt="edit"></a>
                  <a @click.prevent="deleteMethod(item.id)" style="margin-right: 0.3vw;" href="#"><img
                      class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          <table class="table table-striped" v-if="allItems.length && list_complete.length && type_show === 2 && !search_mode">
            <tbody>
            <tr>
              <th rowspan="2"><strong>ردیف</strong></th>
              <th rowspan="2"><strong>نشانه مسئله</strong></th>
              <th rowspan="2"><strong>عنوان مسئله</strong></th>
              <th rowspan="2"><strong>نماگر مسئله</strong></th>
              <th rowspan="2"><strong>سطح مسئله</strong></th>
              <th rowspan="2"><strong>ماموریت</strong></th>
              <th colspan="3"><strong>خدمت متناظر</strong></th>
              <th rowspan="2"><strong>دوره چرخه </strong></th>
              <th v-if="show_insert" rowspan="2" colspan="3"><strong>عملیات</strong></th>
            </tr>
            <tr>
              <th>کلان خدمت</th>
              <th>زیرخدمت</th>
              <th>دستگاه‌های تابعه همکار</th>
            </tr>
            <tr v-for="(item, index) in list_complete">
              <td>{{ index + 1 }}</td>
              <td>{{ item.sign }}</td>
              <td>{{ item.title }}</td>
              <td STYLE="width: 8vw;">
                <span class="btn btn-submit-1 btn-primary" style="cursor: pointer;  "
                      @click="photographerFetchAll(item.id)">تکمیل / بروزرسانی</span>
              </td>
              <td>{{ item.type }}</td>
              <td>{{ item.determining_missions && item.determining_missions.axis }}</td>
              <td>{{ item.processes && item.processes.title }}</td>
              <td>
                <span style="cursor: pointer; color: blue !important"
                      @click="showItemsSubProcess(item.id)">مشاهده</span>
              </td>
              <td>{{ item.collaborative_devices }}</td>
              <td>{{ (item.circle && item.circle.name) ?? '--' }}</td>

              <td v-if="show_insert">
                <div class="d-flex justify-content-evenly">
                  <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img"
                                                                        src="/img/pen.6428fd02.svg" alt="edit"></a>
                  <a @click.prevent="deleteMethod(item.id)" style="margin-right: 0.3vw;" href="#"><img
                      class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          <table class="table table-striped" v-if="incompleteItems.length && type_show === 3 && !search_mode">
            <tbody>
            <tr>
              <th rowspan="2"><strong>ردیف</strong></th>
              <th rowspan="2"><strong>نشانه مسئله</strong></th>
              <th rowspan="2"><strong>عنوان مسئله</strong></th>
              <th rowspan="2"><strong>نماگر مسئله</strong></th>
              <th rowspan="2"><strong>سطح مسئله</strong></th>
              <th rowspan="2"><strong>ماموریت</strong></th>
              <th colspan="3"><strong>خدمت متناظر</strong></th>
              <th rowspan="2"><strong>دوره چرخه </strong></th>
              <th v-if="show_insert" rowspan="2" colspan="3"><strong>عملیات</strong></th>
            </tr>
            <tr>
              <th>کلان خدمت</th>
              <th>زیرخدمت</th>
              <th>دستگاه‌های تابعه همکار</th>
            </tr>
            <tr v-for="(item, index) in incompleteItems">
              <td>{{ index + 1 }}</td>
              <td>{{ item.sign }}</td>
              <td>{{ item.title }}</td>
              <td STYLE="width: 8vw;">
                <span class="btn btn-submit-1 btn-primary" style="cursor: pointer;  "
                      @click="photographerFetchAll(item.id)">تکمیل / بروزرسانی</span>
              </td>
              <td>{{ item.type }}</td>
              <td>{{ item.determining_missions && item.determining_missions.axis }}</td>
              <td>{{ item.processes && item.processes.title }}</td>
              <td>
                <span style="cursor: pointer; color: blue !important"
                      @click="showItemsSubProcess(item.id)">مشاهده</span>
              </td>
              <td>{{ item.collaborative_devices }}</td>
              <td>{{ (item.circle && item.circle.name) ?? '--' }}</td>

              <td v-if="show_insert">
                <div class="d-flex justify-content-evenly">
                  <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img"
                                                                        src="/img/pen.6428fd02.svg" alt="edit"></a>
                  <a @click.prevent="deleteMethod(item.id)" style="margin-right: 0.3vw;" href="#"><img
                      class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br>
        <hr v-if="allItems.length">

        <div v-if="allItems.length" class="d-flex align-items-center justify-content-center">
          <a :href="`${this.download_url}/Problem_identification/all/word/by/id/${id_user}?token=${$cookies.get('id_login')}`"
             style="margin-top: 1.3vw; margin-left: 2vw;"
             class="btn btn-primary btn-submit-1">خروجی Word</a>
          <a
              v-if="not_show"
              :style="$cookies.isKey('type_2') ? 'width: 10vw': ''"
              style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green"
              class="btn btn-primary btn-submit-1 "


          >
            <div v-if="!status_loading">

              <span @click="acceptComplete" v-if="!$cookies.isKey('type_2')">  تایید </span>
              <span @click="acceptCompleteModal=true" v-else>    ارائه جهت تایید مدیر</span>

            </div>

            <div v-else>
              <div class="loader-line"></div>

            </div>
          </a>
          <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal"
               style="z-index: 999999999999999; top: 40%;">
            <div>
              <p>اخطار</p>
              <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
            </div>
            <div>
              <p>آیا از ارائه به مدیر مطمئن هستید؟</p>

              <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
                <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back"
                        type="submit">برگشت
                </button>
                <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
              </div>
            </div>
          </div>
          <a v-if="!$cookies.isKey('type_2') && not_show"
             style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  "
             class="btn btn-primary btn-submit-1 "
             @click="acceptComplete2"
          >
            <div v-if="!status_loading2">
              <span>عدم تایید</span>
            </div>

            <div v-else>
              <div class="loader-line"></div>

            </div>
          </a>
        </div>
      </div>


    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id_item)">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>دلایل عدم تایید</p>
      <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{ textAlert }}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
      <p @click="showReSubmit=!showReSubmit">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{ textAlert }}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button @click="acceptComplete4" class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allSubProcessModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>زیر فرآیند </p>
      <p @click="allSubProcessModal=!allSubProcessModal">❌</p>
    </div>
    <div style="overflow-y:scroll; width: 100%; height: 10vw;">
    
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw !important;">انتخاب</th>
          <th>زیر خدمت</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item, index) in sub_processes_items" :key="item.process.id">
          <td style="width: 1vw;" scope="row"><input :id="`d1d_${item.id}`" v-model="ListSubSelected" type="checkbox"
                                                     :value="item['process']['id']"></td>
          <td>
            {{ item.process.title }}
          </td>
        </tr>

        </tbody>
      </table>
    </div>
    <hr>
    <div class="d-flex align-items-center flex-row">
      <button class="btn-submit-1 btn-primary" @click="allSubProcessModal=false">تایید</button>
      <button class="btn-submit-1 mx-2 btn-primary bg-danger border-danger" @click="resetSend">هیچکدام</button>
    </div>
  </div>

<div dir="rtl" class="modal__error slide-top" v-show="allProcessModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>کلان خدمت</p>
      <p @click="allProcessModal=!allProcessModal">❌</p>
    </div>
    <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw !important;">انتخاب</th>
          <th>کلان خدمت</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item, index) in processes_items" :key="item.id">
          <td style="width: 1vw;" scope="row"><input :id="`d1d_${item.id}`" v-model="ListProcessSelected" type="checkbox"
                                                     :value="item['id']"></td>
          <td>
            <label :for="`d1d_${item.id}`">{{ item.title }}</label>
          </td>
        </tr>

        </tbody>
      </table>
    </div>
    <hr>
    <div class="d-flex align-items-center flex-row">
      <button class="btn-submit-1 btn-primary" @click="ProcessModalsave">تایید</button>
      <button class="btn-submit-1 mx-2 btn-primary bg-danger border-danger" @click="resetSend">هیچکدام</button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModalSubProcess"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>زیرخدمت ها </p>
      <p @click="allItemsModalSubProcess=!allItemsModalSubProcess">❌</p>
    </div>
    <div v-if="allItemsListSubProcess.length" style="overflow-y:scroll; width: 100%; height: 10vw;">
      <div class="table-responsive w-100">

        <table class="table table-striped">
          <thead>
          <tr>
            <th class="sticky-header" style="width: 1vw;">ردیف</th>
            <th class="sticky-header">نام</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in allItemsListSubProcess">
            <td>{{ index + 1 }}</td>
            <td>{{ item }}</td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="photographerModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%; width: 52vw !important;">
    <div class="d-flex justify-content-between mb-3" style="flex-direction: row">
      <p>نماگر ها </p>
      <p @click="photographerModal = !photographerModal">❌</p>
    </div>

    <div v-if="show_insert" class="d-flex flex-nowrap w-100 justify-content-between">
      <!-- فرم ورودی اطلاعات -->
      <div class="mx-2">
        <label class="required">عنوان نماگر </label>
        <textarea v-model="title_photographer" class="form-control" cols="30" rows="30"></textarea>
      </div>
      <div>
        <label class="required">نوع نماگر </label>
        <textarea v-model="type_photographer" class="form-control" cols="30" rows="30"></textarea>
      </div>
      <div class="mx-2">
        <label class="required">فرمول </label>
        <textarea v-model="formula" class="form-control" cols="30" rows="30"></textarea>
      </div>
      <div>
        <label class="required">مقدار کنونی </label>
        <input v-model="value_now" type="text" class="form-control">
      </div>
      <div class="mx-2">
        <label class="required">مقدار مطلوب </label>
        <input v-model="value_optimal" type="text" class="form-control">
      </div>
      <div class="mx-2">
        <label class="required">مرجع اخذ داده </label>
        <input v-model="collection_reference" type="text" class="form-control">
      </div>
    </div>

    <div v-if="show_insert" class="d-flex align-items-center justify-content-center mt-3">
      <button v-if="!is_edit_photographer" class="btn btn-primary btn-submit-1" @click="saveKey">ذخیره</button>
      <button v-if="is_edit_photographer" class="btn btn-primary btn-submit-1" @click="updateKey(this.idToDelete)">
        ویرایش
      </button>
      <Reset @click.prevent="resetData" style="height: 2vw;" class="mx-2"/>
    </div>

    <br>

    <!-- لیست نماگرها -->
    <div v-if="allItemsListKeys.length" class="mt-3 " style="overflow-y:scroll; width: 100%; height: 10vw;">
      <div class="table-responsive w-100 ">

        <table class="table table-striped bg-white">
          <thead class="sticky-header">
          <tr class="sticky-header">
            <th style="width: 1vw;">ردیف</th>
            <th>عنوان نماگر</th>
            <th>نوع نماگر</th>
            <th>فرمول</th>
            <th>مقدار
              کنونی
            </th>
            <th>مقدار مطلوب</th>
            <th>مرجع اخذ داده</th>
            <th v-if="show_insert">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in allItemsListKeys" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title_photographer }}</td>
            <td>{{ item.type_photographer }}</td>
            <td>{{ item.formula }}</td>
            <td>{{ item.value_now }}</td>
            <td>{{ item.value_optimal }}</td>
            <td>{{ item.collection_reference }}</td>
            <td v-if="show_insert">
              <div class="d-flex justify-content-evenly">
                <a @click.prevent="editKey(item.id,item.title_photographer,item.type_photographer,item.formula,item.value_now,item.value_optimal,item.collection_reference)"
                   href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
                <a @click.prevent="showDeleteModal(item.id)" style="margin-right: 0.3vw;" href="#"><img
                    class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModalKey" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModalKey = false">❌</p>
    </div>
    <div>
      <p>آیا می‌خواهید این مورد را حذف کنید؟</p>
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModalKey = false" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItem()">تایید</button>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import vSelect from "vue-select";
import {useToast} from "vue-toastification";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import ItemsWaiting from "@/components/Loaders/ItemsWaiting.vue";

const toast = useToast();

export default {
  components: {
    ItemsWaiting,
    Reset,
    Sidebar,
    splash,
    vSelect

  },
  data() {
    return {
      // showing
      filterModal: false,
      type_show: 1,
      //photographerModal
      photographerModal: false,
      is_edit_photographer: false,
      issue_id: '',
      // **************
      is_fetch: true,
      status_loading2: false,
      showReSubmit: false,
      allSubProcessModal: false,
      allProcessModal: false,
      allItems: [],
      Process: [],
      allItemsDetermining_Mission: [],
      sub_processes_items: [],
      sub_processes_items_all:[],
      processes_items: [],
      ListSubSelected: [],
      ListProcessSelected: [],
      Determining_Mission: '',
      n_process: 1,
      n_processes:[],
      
      sub_process: '',
      sign: '',
      title: '',
      type: '',
      title_photographer: '',
      type_photographer: '',
      formula: '',
      value_now: '',
      value_optimal: '',
      collection_reference: '',
      collaborative_devices: '',
      determining_missions_id: '',
      processes_id: '',
      sub_processes_id: '',
      id_user: '',
      period: '',
      id_item: '',
      is_update: false,
      deleteModal: false,
      status_show: false,
      status_loading: false,
      show_insert: false,
      status_seconder: false,
      isWrite: false,
      status_approver: false,
      infoCancelled: false,
      text_info: '',
      seconder_ban: false,
      approver_ban: false,
      textAlert: '',
      infoCancelledModal: false,
      status_seconder_step: false,
      acceptCompleteModal: false,
      allItemsListSubProcess: [],
      allItemsModalSubProcess: false,
      deleteModalKey: false,
      idToDelete: null,
      allItemsListKeys: [],
      allItemsListPeriods: [],
      Periods_id: [],
      list_complete: [],
      selected_periods: [],
      // search
      all_search: [],
      search_mode: false,
      not_show: true,
      events: [],
      selectedEventId: null,
    }
  },
  computed: {
    activeEvent() {
      return this.events.find(event => event.status === 1)
    },
    incompleteItems() {
      const allItems = this.allItems || [];
      const completedItems = this.list_complete || [];
      const completedIds = new Set(completedItems.map(item => item.id));

      return allItems.filter(item => !completedIds.has(item.id));
    },
  },
  methods: {


ProcessModalsave() {
  this.allProcessModal = false

  // پاک‌سازی قبلی
  this.sub_processes_items = []
  this.ListSubSelected = []

  // 1. گرفتن فرآیندهایی که آیدی‌شون توی ListProcessSelected هست
  const selectedProcesses = this.processes_items.filter(process =>
    this.ListProcessSelected.includes(process.id)
  )

  

  // 2. گرفتن کدهای فرآیندهای انتخاب شده
  const selectedProcessCodes = selectedProcesses.map(p => p.code)

  // 3. فیلتر کردن زیر فرآیندها بر اساس parent_id برابر با کد فرآیندهای انتخاب شده
  this.sub_processes_items_all.forEach(subProcess => {
    if (selectedProcessCodes.includes(subProcess.process.parent_id)) {
      this.sub_processes_items.push(subProcess)
      //this.ListSubSelected.push(subProcess.process.id)

      
    }
  })

  console.log(this.sub_processes_items)
}

,
    
    searchPeriodsFilter(active) {
      this.all_search.length = 0
      if (active) {
        this.allItems.forEach((ele) => {
          if (this.selected_periods.includes(ele.event_id)) {
            this.all_search.push(ele);
          }
          this.search_mode = true
        });
      } else {
        this.search_mode = false
        this.all_search.length = 0
        this.selected_periods.length = 0
      }
      this.toggleModal()
    },

    toggleModal() {

      this.filterModal = !this.filterModal
    },
    toggleType(type) {
      this.type_show = type;
    },

    

    all_complete() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('sange', '')


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Problem_identification/all_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }

            this.events = response.data.events;
            this.selectedEventId = this.activeEvent?.id;

            if (response.data && response.data.incomplete_problems) {
              this.list_complete.length = 0
              response.data.incomplete_problems.details.forEach((ele) => {
                this.list_complete.push(ele)
              })
            }

          })
          .catch();
    },
    // Periods
    allPeriods() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('sange', '')


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            if (response.all) {
              this.allItemsListPeriods.length = 0
              response.all.forEach((ele) => {
                this.allItemsListPeriods.push(ele)
              })
            }

          })
          .catch();
    },
    // keys
    photographerFetchAll(id) {
      this.issue_id = id
      this.photographerModal = true
      fetch(`${this.base_url}/problem-photographers/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.$cookies.get('token')}` // اگر احراز هویت دارید
        },

      })
          .then(response => response.json())
          .then(result => {
            if (result.all) {
              this.resetData(); // بازنشانی اطلاعات فرم
              this.allItemsListKeys = result.all
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور');
            console.error('Error:', error);
          });
    },
    saveKey() {
      const data = {
        issue_id: this.issue_id,
        title_photographer: this.title_photographer,
        type_photographer: this.type_photographer,
        formula: this.formula,
        value_now: this.value_now,
        value_optimal: this.value_optimal,
        collection_reference: this.collection_reference
      };

      fetch(`${this.base_url}/problem-photographers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.$cookies.get('token')}` // اگر احراز هویت دارید
        },
        body: JSON.stringify(data)
      })
          .then(response => response.json())
          .then(result => {
            if (result.message) {
              toast.success(result.message);
              this.resetData(); // بازنشانی اطلاعات فرم
              this.photographerFetchAll(this.issue_id); // بازنشانی اطلاعات فرم
            } else {
              toast.error('خطا در ذخیره‌سازی');
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور');
            console.error('Error:', error);
          });
    },
    updateKey(id) {
      const data = {

        title_photographer: this.title_photographer,
        type_photographer: this.type_photographer,
        formula: this.formula,
        value_now: this.value_now,
        value_optimal: this.value_optimal,
        collection_reference: this.collection_reference
      };

      fetch(`${this.base_url}/problem-photographers/${this.idToDelete}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.$cookies.get('token')}`
        },
        body: JSON.stringify(data)
      })
          .then(response => response.json())
          .then(result => {
            if (result.message) {
              toast.success(result.message);
              this.resetData();
              this.photographerFetchAll(this.issue_id);
            } else {
              toast.error('خطا در بروزرسانی');
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور');
            console.error('Error:', error);
          });
    },
    editKey(id, title_photographer, type_photographer, formula, value_now, value_optimal, collection_reference) {
      this.idToDelete = id
      this.title_photographer = title_photographer
      this.type_photographer = type_photographer
      this.formula = formula
      this.value_now = value_now
      this.value_optimal = value_optimal
      this.collection_reference = collection_reference
      this.is_edit_photographer = true
    },
    showDeleteModal(id) {
      this.idToDelete = id; // ذخیره آی‌دی موردی که باید حذف شود
      this.deleteModalKey = true; // نمایش مودال
    },
    deleteItem() {
      fetch(`${this.base_url}/problem-photographers/${this.idToDelete}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${this.$cookies.get('token')}`
        }
      })
          .then(response => response.json())
          .then(result => {
            if (result.message) {
              toast.success(result.message);
              this.deleteModalKey = false; // بستن مودال پس از حذف موفقیت‌آمیز
              this.photographerFetchAll(this.issue_id);

            } else {
              toast.error('خطا در حذف');
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور');
            console.error('Error:', error);
          });
    },


    // ****************
    resetSend() {
      this.allSubProcessModal = false
      this.allProcessModal= false,
      this.ListSubSelected.length = 0
      this.ListSelected.length = 0
    },
    showItemsSubProcess(id) {
      this.allItemsListSubProcess.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/all_items/subProcess/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            response.items.forEach((item) => {
              this.allItemsListSubProcess.push(item)
            })
            this.allItemsModalSubProcess = true
          })
          .catch();
    },

    setShow(){
      if (this.$cookies.isKey('type_2')){
        if (this.status_show===false){
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete() {
      this.acceptCompleteModal = false

      if (this.status_show) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      if (this.seconder_ban || this.approver_ban) {
        this.showReSubmit = true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)

              this.status_show = !this.status_show
              this.status_loading = false
              this.all()

            }
            this.infoCancelled = false

          })
          .catch();

    },
    acceptComplete4() {
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false
            this.showReSubmit = false

          })
          .catch();
    },
    acceptComplete2() {

      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3() {
      this.status_loading2 = true
      if (!this.status_show) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info) {
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/Problem_identification/update_complete`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    editMethod(id) {
      this.id_item = id
      this.ListSubSelected.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Problem_identification/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const item = response.item


            this.is_update = true

            if (item) {
              this.sign = item.sign
              this.title = item.title
              this.type = item.type
              this.title_photographer = item.title_photographer
              this.type_photographer = item.type_photographer
              this.formula = item.formula
              this.value_now = item.value_now
              this.value_optimal = item.value_optimal
              this.collection_reference = item.collection_reference
              this.collaborative_devices = item.collaborative_devices
              this.period = item.period
              this.Determining_Mission = item.determining_missions
              this.Periods_id = item.circle_id
              this.selectedEventId = item.event_id
            }
          })
          .catch();


    },
    update(id) {
      if (!this.sign.length) {
        toast.error('نشانه مسئله اجباری است!')
        return
      } else if (!this.title.length) {
        toast.error('عنوان مسئله اجباری است!')
        return;
      } else if (!this.type.length) {
        toast.error('سطح مسئله اجباری است!')
        return;
      }

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('sign', this.sign)
      formdata.append('title', this.title)
      formdata.append('type', this.type)
      formdata.append('title_photographer', this.title_photographer)
      formdata.append('type_photographer', this.type_photographer)
      formdata.append('formula', this.formula)
      formdata.append('value_now', this.value_now)
      formdata.append('value_optimal', this.value_optimal)
      formdata.append('collection_reference', this.collection_reference)
      formdata.append('collaborative_devices', this.collaborative_devices)
      formdata.append('determining_missions_id', this.determining_missions_id)
      formdata.append('processes_id', JSON.stringify(this.ListProcessSelected))
      formdata.append('sub_processes_id', JSON.stringify(this.ListSubSelected))
      formdata.append('period', this.period)
      formdata.append('event_id', this.selectedEventId)

      formdata.append('sub_process', JSON.stringify(this.ListSubSelected))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.resetData()
            this.all()
            this.is_update = false
          })
          .catch();
    },
    resetItems() {
      // this.resetModel()
      this.is_update = false
      this.id_item = ''
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Problem_identification/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message) {
              toast.success(response.message)
              this.id_item = ''
              this.deleteModal = false
              this.all()

            }
          })
          .catch();
    },
    deleteMethod(id) {
      this.id_item = id
      this.deleteModal = true

    },
    store() {
      if (!this.sign.length) {
        toast.error('نشانه مسئله اجباری است!')
        return
      } else if (!this.title.length) {
        toast.error('عنوان مسئله اجباری است!')
        return;
      } else if (!this.type.length) {
        toast.error('سطح مسئله اجباری است!')
        return;
      }

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('sign', this.sign)
      formdata.append('title', this.title)
      formdata.append('type', this.type)
      formdata.append('title_photographer', this.title_photographer)
      formdata.append('type_photographer', this.type_photographer)
      formdata.append('formula', this.formula)
      formdata.append('value_now', this.value_now)
      formdata.append('value_optimal', this.value_optimal)
      formdata.append('collection_reference', this.collection_reference)
      formdata.append('collaborative_devices', this.collaborative_devices)
      formdata.append('determining_missions_id', this.determining_missions_id)
      formdata.append('processes_id',  JSON.stringify(this.ListProcessSelected))
      formdata.append('sub_process', JSON.stringify(this.ListSubSelected))
      if (this.sub_process) {
        formdata.append('sub_processes_id', JSON.stringify(this.ListSubSelected))
      }

      formdata.append('period', this.period)
      formdata.append('event_id', this.selectedEventId)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.resetData()
            this.all()
          })
          .catch();
    },
      all() {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/Problem_identification/all`, requestOptions)
            .then(response => response.json())
            .then(response => {
              this.status_seconder = false
              this.seconder_ban = false
              this.status_seconder_step = false
              this.approver_ban = false
              this.status_approver = false
              if (response.error) {
                toast.error(response.error)
                return
              }
              if (response.status) {
                this.status_show = true
              }
              this.allItems.length = 0
              response.all.forEach((item) => {
                this.allItems.push(item)

              })

              this.is_fetch = false

              if (!response.status_seconder) {
                if (response.status) {
                  this.status_seconder = true
                }
              }
              if (!this.status_approver && this.$cookies.isKey('type_1')) {
                this.status_seconder = false
              }
              if (response.status && !response.status_approver) {
                this.status_seconder = true
              }
              if (response.seconder_ban) {
                this.seconder_ban = true
                this.textAlert = response.message ?? 'موردی یافت نشد'
              }
              if (response.approver_ban) {
                this.approver_ban = true
                this.textAlert = response.message ?? 'موردی یافت نشد'
              }

              if (response.status_approver) {
                this.status_approver = true
              }
              if (response.text_seconder) {
                this.seconder_ban = true
                this.textAlert = response.text_seconder ?? 'موردی یافت نشد'
              }
              if (parseInt(response.step) === 1) {
                this.status_seconder_step = true
                this.status_seconder = true
              }
              if (parseInt(response.step) === 2) {
                this.status_seconder_step = true
                this.status_seconder = false
              }
              if (parseInt(response.step) === 0) {
                this.status_seconder_step = false

              }

              if (response.status_insert){
                this.show_insert = response.status_insert
              }
              this.setShow()
              this.all_complete()
              if ((parseInt(response.step)===1&&this.type_two)||(parseInt(response.step)===2&&this.type_two) || (parseInt(response.step)===2&&this.type_one) || parseInt(response.step)===3){
                this.not_show = false
              }
            })

            .catch();
      },
    resetData() {
      this.sign = ''
      this.ListSubSelected.length = 0
      this.is_update = false
      this.title = ''
      this.type = ''
      this.title_photographer = ''
      this.type_photographer = ''
      this.formula = ''
      this.value_now = ''
      this.value_optimal = ''
      this.collection_reference = ''
      this.collaborative_devices = ''
      this.determining_missions_id = ''
      this.processes_id = ''
      this.sub_processes_id = ''

      this.Determining_Mission = ''
      this.sub_process = ''
      this.n_process = ''
      this.period = ''
      this.is_edit_photographer = false

      this.Process.length = 0
      this.sub_processes_items.length = 0

      this.selectedEventId = this.activeEvent?.id;
    },
    setProcess() {
      this.processes_items=[]
      this.ListProcessSelected=[]
      this.ListSubSelected=[]
      this.sub_processes_items=[]
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/select/${this.Determining_Mission.id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.Process.length = 0
            if (response.item) {
  this.Process = response.item

  if (response.item.processes) {
    this.processes_items = response.item.output_processes
    this.determining_missions_id = response.item.id
    this.sub_processes_items_all=response.item.sub_processes_items
  }


}



          })
          .catch();
    },
    allItemsDetermining_Missions() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsDetermining_Mission.length = 0
            response.all.forEach((item) => {
              this.allItemsDetermining_Mission.push(item)

            })
          })
          .catch();
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.logout()
              return;
            }
            if (result['item']) {
              if (this.is_mother) {
                this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    ProductivityPeriod() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ProductivityPeriod/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              this.isWrite = true
              return
            } else {
              this.isWrite = false
            }


          })
          .catch();
    },

    clearBrowserCache() {
      try {
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistrations().then(function(registrations) {
            for (let registration of registrations) {
              registration.unregister();
            }
          });
        }

        if ('caches' in window) {
          caches.keys().then(function(names) {
            for (let name of names) {
              caches.delete(name);
            }
          });
        }

        window.location.reload(true);

        return true;
      } catch (error) {
        console.error('خطا در پاک کردن کش:', error);
        return false;
      }
    }
  },
  mounted() {
    this.allItemsDetermining_Missions()
    this.all()
    this.checkIsMother()
    this.fetchItems()
    this.ProductivityPeriod()
    this.allPeriods()


  },
  watch: {
    Determining_Mission(newValue, oldValue) {
      if (newValue) {
        this.setProcess()
      }
    },
  }
}
</script>
<style scoped lang="scss">
label {
  font-size: 1vw !important;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}

.relative {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 0.5rem;
  padding: 0.5rem;
  z-index: 1000;
  min-width: 200px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
}
</style>